<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>





<div class="container" style="width: 100%; margin-top:60px" *ngIf="data">
  <div class="row" style="margin-top: 30px;">
    <div class="left hidden-sm-down">
      <div class="row">
        <div class='col-12'>
          <div class="card" style="margin-top:1%; padding:4px; padding-left:10px; box-shadow:0 1px 4px rgba(0, 0, 0, .5);">
              <span *ngIf="brand && brand.length> 0">
                  <h4 style="font-style: open sans ;color: #cb983f;">Brand:</h4>
                  <hr>
                    <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                      <div  *ngFor= "let dataa of brand">
                          <div *ngFor="let datan of data | uniqFilter : 'brand_id'">
                             <div *ngIf="datan.brand_id == dataa.id">
                              <label style="font-weight:normal">
                              <input  type="checkbox" name="brand" ngModel="{{isbrandCheck(dataa.id)}}" [value] = "dataa.id"  (change)="filter($event,dataa.id)">
                                {{dataa.name}} ({{brandCount(dataa.id)}})
                               </label>
                              </div>
                             </div>
                            </div>
                         </div>
                   </span>
                   <span *ngIf="flavour">
                      <h4 style="font-style: open sans ;color: #cb983f">Flavour:</h4>
                       <hr>
                       <div class="form-group" style="font-size: 0.9em; color: #9b7544">
                        <div  *ngFor= "let dataa of flavour">
                          <div *ngFor="let datan of data | uniqFilter : 'flavour_id'">
                            <div *ngIf="datan.flavour_id == dataa.id">
                        <label style="font-weight:normal">
                         <input  type="checkbox" name="flavour" ngModel="{{isFlavourCheck(dataa.id)}}" [value] = "dataa.id"  (change)="flavourFilter($event,dataa.id)">
                          {{dataa.name}}
                        </label>
                      </div>
                    </div>
                        </div>
                       </div>
                    </span>
                    <span *ngIf="lifestage">
                        <h4 style="font-style: open sans ;color: #cb983f">Lifestage:</h4>

                       <hr>
                       <div class="form-group" style="font-size: 0.9em; color: #9b7544">

                        <div  *ngFor= "let dataa of lifestage">
                          <div *ngFor="let datan of data | uniqFilter : 'lifestage_id'">
                            <div *ngIf="datan.lifestage_id == dataa.id">

                        <label style="font-weight:normal">
                         <input  type="checkbox" name="lifestage" ngModel="{{isLifeCheck(dataa.id)}}" [value] = "dataa.id"  (change)="lifestageFilter($event,dataa.id)">
                          {{dataa.name}} ({{lifestageCount(dataa.id)}})
                        </label>
                      </div>
                    </div>
                        </div>
                       </div>
                     </span>



          </div>
        </div>
      </div>

    </div>
    <div class="right">

      <div style="float: right" class="wsmobileheader">

               <!-- <a id="wsnavtoggle" class="animated-arrow"><span></span></a>-->

            <button (click)="toggleMenu()" class="filter_list" style="margin: 10px;     color: #9b7544;">
              <i class="material-icons">
              filter_list
              </i>Filter
             </button>


            </div>


      <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="namestring && data">
          <h4 *ngIf=" filterarray.length == 0 && flavourfilterarray.length == 0 && lifestagefilterarray.length == 0" style="font-style: open sans ;color: #cb983f; text-transform: capitalize;">
              {{namestring | slice: 0: namestring.length-5}}:  {{data.length}} items
           </h4>

           <h4 *ngIf="filterarray.length > 0 || flavourfilterarray.length > 0 || lifestagefilterarray.length > 0" style="font-style: open sans ;color: #cb983f; text-transform: capitalize;">
            {{namestring | slice: 0: namestring.length-5}}
         </h4>

      </div>
      <div  class="col-sm-3 col-md-3 col-lg-3 col-xl-3">
      </div>


      </div>
      <div class="row" *ngIf="similercat && similercat.length>0" style="margin-bottom: 20px;    margin-left: -30px;
    margin-right: 0px;    margin-top: 35px;">

      <div class="col-3 text-center" *ngFor="let data of similercat" style=" max-height: 100px; background-color: #fff;
border: 2px solid #dbd3be;">
        <div style="cursor:pointer; margin:2px;  "
        routerLink="/store/products/{{data.id}}/'product.html'">
  <img src="https://passport.petcart.in/images/prodimgs/{{data.image}}" style="float: left;     max-height: 80px;
    max-width: 80px;" class="hidden-md-down">

              <div class="text-center" style="">
                  <p style="color: #9b7544; text-transform: capitalize; overflow-wrap:break-word;">
                      {{data.name}}
                   </p>
            </div>

        </div>
      </div>
    </div>




     <div class="row" *ngIf="data && data.length>0 ; else noproduct" style="margin-top:40px;">
       <div class="prodgrid" style="box-shadow:0 1px 4px rgba(0, 0, 0, .5); margin-right:10px; margin-bottom:10px;" *ngFor="let data1 of data |
        myfilter: filterarray | flavourfilter: flavourfilterarray | productpriceorder:  sortingorder |
         lifestagefilter:  lifestagefilterarray  | paginate: { itemsPerPage: 24, currentPage: p}">
        <div class="card">
          <div style="width:auto;text-align: center; cursor: pointer">
            <img  routerLink="/store/details/{{data1.id}}/{{data1.url}}" class="card-img-top-prod" src="https://passport.petcart.in/images/prodimgs/{{data1.image}}" alt="Card image">
        </div>
      </div>
        <div class="card-body" style="height:150px ; border: 1px solid;     padding: 5px !important;  background-color:#fff; cursor: pointer">
          <div style="min-height:90px;" routerLink="/store/details/{{data1.id}}/{{data1.url}}">
          <span style="font-style:open sans; color: #9b7544;  overflow-wrap: break-word;">
             <h5 routerLink="/store/details/{{data1.id}}/{{data1.url}}"  style="font-size: 1rem;">{{ data1.name }}</h5>
          </span>
          <span style="font-style: open sans; color: #cb983f; font-size:16px;  font-weight:bold;  overflow-wrap: break-word" *ngIf="data1.splprice === 0; ">
              Rs. {{ data1.price }}
          </span>
              <p style="font-style: open sans; color: #cb983f; margin-bottom: 0px !important;
              overflow-wrap: break-word;  font-size:15px" *ngIf="data1.splprice > 0;">
              <del style="color:#c5c5c5">Rs. {{ data1.price }}</del>
              <span style="font-size:15px; float:right;">Rs. {{ data1.splprice }}</span></p>

            </div>
              <div class="row">
              <button *ngIf="status['id'+data1.id] && status['id'+data1.id]==1
              && stock['id'+data1.id] && stock['id'+data1.id]>0 && check == 1 ;else other_content" class="cartbtn"
               (click)="addToCart(data1.name,data1.sku,data1.price,data1.id,data1.splprice)"><i class="material-icons" >&#xE8CC;</i>Add to Cart</button>
               </div>
        </div>

       </div>
     </div>
     <div class="row" *ngIf="data && data.length>0">
       <div class="col-12 text-right" style="font-size:18px">
           <pagination-controls  (pageChange)="p = $event" (click)="windowScroll()"></pagination-controls >
       </div>
     </div>
     <!--<div class="row" *ngIf="owncategory">
      <div class="col-12">
   <div style="border-top: 2px solid #dbd3be; padding-top:20px;">
     <h4><p style="color:#9b7544">{{owncategory.name}}<strong></strong></p></h4>
   </div>
      </div>
      <div class="col-12">
       <p style="overflow-wrap:break-word">{{owncategory.description}}<strong></strong></p>
       </div>
    </div>-->
    </div>
  </div>

  </div>
  <div class="footer">
      <app-footer></app-footer>
  </div>
      <ng-template #noproduct style="color:red;">
              <div class="row">
                  <div class="col-12 text-center">
                      <label style="color: #cb983f;font-size: 25px;">
                          </label>
                  </div>
                </div>


      </ng-template>

      <ng-template #other_content >
        <div *ngIf="check == 1">
               <h5><label class="cartoutstock">Out Of Stock</label></h5>
        </div>
          </ng-template>
